import IconWeb from "/src/assets/img/svg/web.svg";
import IconPhone from "/src/assets/img/svg/telephony.svg";
import IconRcs from "/src/assets/img/svg/rcs.svg";
import IconMessenger from "/src/assets/img/svg/mail.svg";

/*
export default {
    mail: IconWeb,
    sms: IconMessenger,
    phone: IconPhone
}
*/
export default [
    {
        
        value: 1,
        text : <span> <img srcSet={IconWeb}></img> </span>        
    },
    {
        value: 3,
        text: <span> <img srcSet={IconPhone}></img></span>,
    }
]